import React from 'react';
import { AFFILIATE_URL } from '../data/mock';

const AffiliateLink = ({ children, className = '', style = {} }) => {
  const handleClick = (e) => {
    e.preventDefault();
    window.open(AFFILIATE_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <a
      href={AFFILIATE_URL}
      onClick={handleClick}
      className={`cursor-pointer ${className}`}
      style={style}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
};

export default AffiliateLink;